import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterDesc",
  pure: false,
})
export class FilterDescPipe implements PipeTransform {
  transform(description: string): string {
    if (description.trim() === "none") {
      return "";
    }

    return description;
  }
}
